import { graphql } from '@client/graphql/types';
import { useQuery } from '@apollo/client';
import { Service } from '@client/graphql/types/graphql.ts';

const QUERY = graphql(`
  query getTemporaryAvailabilityLimitations($branchId: ID!, $service: Service!) {
    getTemporaryAvailabilityLimitations(branchId: $branchId, service: $service) {
      ...TemporaryAvailabilityLimitationItem
    }
  }
`);

export default function useTemporaryAvailabilityLimitations(branchId: string, service: Service) {
  return useQuery(QUERY, {
    variables: {
      branchId,
      service,
    },
  });
}
